import { invert } from 'lodash-es';
import { DEVICE_TYPE } from '../../../components/StatelessComponent/SingleFilter/DeviceTypeFilter/DeviceFilterType';
import type { IntermediateFormat } from '../../../domains/global-filters/model/IntermediateFormat';
import type { QueryFormatFilter } from '../../../domains/global-filters/model/QueryFormat';
import { QueryKeyEnum } from '../../../domains/global-filters/model/QueryFormat';
import * as ShortStringListConverter from './GenericConverter/ShortStringListConverter';

const queryValueByUiValue: Record<DEVICE_TYPE, string> = {
  [DEVICE_TYPE.DESKTOP]: 'desktop',
  [DEVICE_TYPE.PHONE]: 'phone',
  [DEVICE_TYPE.TABLET]: 'tablet',
};

const uiValueByQueryValue = invert(queryValueByUiValue) as Record<string, DEVICE_TYPE>;

export function fromUiToQueryFormat(uiValue?: DEVICE_TYPE[]): QueryFormatFilter {
  if (!uiValue) {
    throw new Error(`uiValue is undefined`);
  }
  return ShortStringListConverter.fromUiToQueryFormat(
    uiValue,
    QueryKeyEnum.device,
    queryValueByUiValue,
  );
}

export function fromIntermediateToUiFormat(intermediateValue: IntermediateFormat): DEVICE_TYPE[] {
  return ShortStringListConverter.fromIntermediateToUiFormat(
    intermediateValue,
    uiValueByQueryValue,
  );
}
